const MembersData = [
  {
    number: 'abc1',
    name: 'user',
    investmentType: '소득적격',
    doc: [],
  },
  {
    number: 'abc2',
    name: 'user',
    investmentType: '소득적격',
    doc: [],
  },
  {
    number: 'abc3',
    name: 'user',
    investmentType: '소득적격',
    doc: [],
  },
  {
    number: 'abc4',
    name: 'user',
    investmentType: '소득적격',
    doc: [],
  },
  {
    number: 'abc5',
    name: 'user',
    investmentType: '소득적격',
    doc: [],
  },
];

export default MembersData;
